import styled from 'styled-components';
import * as colors from 'components/common/colorConstants';

export const Progress = styled.div`
  height: 2px;
  background-color: ${colors.darkGray16};
  width: ${(props) => (props.progress ? `${props.progress}%` : '0%')};
  min-width: 3px;
`;

export const Bar = styled.div`
  width: 29px;
  margin: 5px 4px 0px 0px;
  height: 2px;
  background-color: ${colors.lightGray37};
  text-align: left;
  border-radius: 1px;
`;
